export default "__VITE_ASSET__9e61cccf__"